/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { TDndDropAreaID } from "../Dnd/DndTypes";

export interface IDndDropAreaContext {
	droppableId: TDndDropAreaID;
	draggignOver: boolean;
}

export const DndDropAreaContext = React.createContext<IDndDropAreaContext>(null);

export function useDndDropAreaContext(): IDndDropAreaContext {
	return useContext(DndDropAreaContext);
}
